
import {_util} from '../../utils/pmss'


export default {
    inserted(el, binding, vnode) {
        const { value } = binding
        //const $roles = store.getters && store.getters['user/roles']
        // console.log(value)
        if (value) {
            if(value instanceof Array){
                debugger
                var noPermission = true;
                for(var i=0;i<value.length;i++){
                    const url = value[i].url;
                    const permission = value[i].permission

                    var hasPermission =  _util.hasPermission(url, permission)
                    noPermission = !hasPermission;
                    if (noPermission === false) {
                        break
                    }
                }
                if (noPermission === true) {
                    el.parentNode && el.parentNode.removeChild(el)
                }
            }else{
                const url = value.url;
                const permission = value.permission

                var hasPermission =  _util.hasPermission(url, permission)
                var noPermission = !hasPermission;
                if (noPermission === true) {
                    el.parentNode && el.parentNode.removeChild(el)
                }
            }
        } else {
            throw new Error(`need permission!`)
        }
    }

}
